import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RdsProgressSpinnerComponent } from '@rds/angular-components';

@Component({
  selector: 'inexp-focus-form-manager',
  standalone: true,
  imports: [RouterOutlet, RdsProgressSpinnerComponent],
  templateUrl: './focus-form-manager.component.html',
  styleUrl: './focus-form-manager.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FocusFormManagerComponent {}
